<template>
	<div class="view-wrapper contact" v-if="document">
		<c-map />
		<div class="container">
			<h1>{{ document.title }}</h1>

			<div class="contact__addresses">
				<div class="contact__address" v-for="item in document.contact_section_repeater" v-html="item.content" />
			</div>
		</div>
	</div>
</template>

<script>
import * as utils from '@/utils/utils'
import defaultHeadData from '@/utils/defaultHeadData'
import getContactData from '@/api/contact.wp.api'
import CMap from '@/components/Map'

export default {
	name: 'contact',
	components: {
		CMap
	},
	data: () => ({
		documentData: null,
		headData: defaultHeadData
	}),
	computed: {
		settings() {
			return this.$store.state.general.settings
		},
		defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta
		},
		siteSettings() {
			return this.$store.state.general.siteSettings
		},
		activeRouteUrl() {
			return utils.constructActiveRouteUrl(this.$route.fullPath)
		},
		document() {
			return this.documentData
		}
	},
	watch: {
		'$route': function() {
			this.setContactData()
			this.updateHeadData()
		},
		defaultMeta: function() {
			this.updateHeadData()
		}
	},
	head: {
		title: function() {
			return utils.transformHeadTitle(this.headData.title)
		},
		meta: function() {
			return utils.transformHeadMeta(this.headData.meta)
		},
		link: function() {
			return utils.transformHeadLink({ data: this.headData.link, i18n: true })
		}
	},
	beforeMount() {
		this.setContactData()
		this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/contact' })
		this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en/contact' })
	},
	methods: {
		setContactData() {
			this.documentData = null
			getContactData({ lang: this.settings.currentLang }).then(payload => {
				this.documentData = payload
				utils.setHtmlLang(this.settings.currentLang)
				this.updateHeadData()
			})
			.catch(() => {
				this.$router.push({ path: '/404' })
			})
		},
		updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.documentData) {
				this.headData = utils.transformHeadData({
					meta: this.documentData.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				})
				this.$emit('updateHead')
			}
		}
	}
}
</script>

<style lang="scss" module>
	.about {
		&__address {
			width: 50%;

			p {
				color: black;
			}
		}
	}
</style>

<style lang="scss">

	@import '../assets/css/main';

	.contact {
		padding-top: 20rem;
		padding-bottom: 5rem;
		position: relative;

		@include mq($from: medium) {
			padding-bottom: 10rem;
		}

		h1 {
			font-size: 2rem;
			color: $colorBrandMain;
			font-weight: 600;

			@include mq($from: medium) {
				font-size: 3rem;
			}
		}
		&__titlecontainer {
			pointer-events: none;
		}

		.container {
			z-index: 2;
		}

		&__addresses {
			display: flex;
			flex-wrap: wrap;
			padding-top: 1rem;
		}
		&__address {
			width: 100%;
			margin-bottom: 2rem;

			@include mq($from: medium) {
				width: 50%;
				margin-bottom: 0;
			}

			h2 {
				font-weight: 600;
				margin-bottom: 1rem;
			}

			p + p {
				margin-top: 1rem;
			}

			a {
				color: $colorGray;
				text-decoration: none;

				&:hover {
					color: $colorDark;
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// Contact.vue?ac3a6164